import { Component } from "@angular/core";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { NavigationItem } from "@rubbl-layout";
import { filter } from "rxjs";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent {
  navigationItems: NavigationItem[] = [
    {
      label: "Orders",
      children: [
        { label: "Active Order Items", route: "/order/orderitems" },
        { label: "Orders", route: "/order/items" },
        { label: "Carts", route: "/order/carts" },
        { label: "Service", route: "/order/service" },
        { label: "Map", route: "/order/map" },
      ],
    },
    {
      label: "Accounts",
      children: [
        { label: "Accounts", route: "/account" },
        { label: "Connect", route: "/account/connect" },
        { label: "Pending Tasks", route: "/account/activities" },
      ],
    },
    {
      label: "Inventory",
      children: [
        { label: "Machines", route: "/inventory" },
        { label: "Groups", route: "/inventory/groups" },
        { label: "Attachments", route: "/inventory/attachments" },
        { label: "GPS Devices", route: "/inventory/gps-devices" },
      ],
    },
    { label: "Ecom", route: "/ecom" },
    { label: "Inspections", route: "/inspection" },
    { label: "Billing", route: "/billing" },
    {
      label: "Dashboard",
      route: "/dashboard",
    },
    {
      label: "Platform",
      children: [{ label: "Monitoring", route: "/platform/monitoring" }],
    },
    {
      label: "Onboarding",
      route: "/onboarding",
    },
    {
      label: "Coupons",
      route: "/coupon",
    },
    {
      label: "Rubbl Connect",
      route: "/connect",
    },
  ];

  constructor(private router: Router) {}

  addContainerClass: boolean = false;

  ngOnInit() {
    if (window.location.pathname.includes("order/map")) {
      // this.addContainerClass = false;
    }

    this.router.events.pipe(filter(event => event instanceof NavigationStart)).subscribe((result: any) => {
      // if (result.url.includes("order/map")) {
      //   this.addContainerClass = false;
      // } else {
      //   this.addContainerClass = true;
      // }
    });
  }
}
